import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCYJxHuvNMJxZEZwG-wfVPCuLQSRq9o3_s",
  authDomain: "groupexptracker.firebaseapp.com",
  projectId: "groupexptracker",
  storageBucket: "groupexptracker.firebasestorage.app",
  messagingSenderId: "959995864066",
  appId: "1:959995864066:web:997e66da2c026f2355331b",
  measurementId: "G-LKM22YNCEW"
};


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
